module.exports = __webpack_public_path__ + "img/gb-nir.abef6ce9.svg";